import React, { useEffect, useState } from "react";
import classes from "./RegisterOrders.module.css";
import DefaultInput from "../../components/form/DefaultInput";
import { ReactComponent as Attachment } from "../../assets/attachment-upload-alt.svg";
import { Button, Spin, Upload } from "antd";
import { ReactComponent as InfoIcon } from "../../assets/info-circle-filled.svg";
import { AgGridReact } from "ag-grid-react";
import { ColDef } from "ag-grid-community";
import { fetchZones, getAllCustoms } from "../../lib/OptionListApi";
import { ReactComponent as ArrowUp } from "../../assets/up-arrow.svg";
import { ReactComponent as ArrowDown } from "../../assets/arrow-line-Down (2).svg";
import DefaultExcelImport from "../../components/form/DefaultExcelImport";
import api from "../../utils/axios";
import { toast } from "react-toastify";
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Typography,
} from "@mui/material";
import useLang from "../../hooks/useLang";
import Map from "../Dashboard/Map";

const RegisterOrders = () => {
	const { strings } = useLang("registerOrders");

	const [tableColumns, setTableColumns] = useState<ColDef[]>();
	const [zones, setZones] = useState([]);
	const [loading, setLoading] = useState<any>(false);
	const [customs, setCustoms] = useState<any>([]);
	const [ordersCountByCity, setOrdersCountByCity] = useState<any[]>([]);
	const [countryId, setCountryId] = useState(null);
	const [hoveredCity, setHoveredCity] = useState<string>("");
	const [expandedCountryId, setExpandedCountryId] = useState<number | null>(
		null
	);
	const [clickedCity, setClickedCity] = useState<string>("");

	const data = [
		{
			id: 1,
			kolona: strings?.kolona1,
			plotësimi: `\u25CF ${strings?.optional}`,
			lloji: strings?.typeColumn,
			// default: "S",
		},
		{
			id: 1,
			kolona: strings?.kolona2,
			plotësimi: `\u25CF ${strings?.optional}`,
			lloji: strings?.typeColumn,
			// default: "S",
		},
		{
			id: 2,
			kolona: strings?.nameBuyer,
			plotësimi: `\u25CF ${strings?.forced}`,
			lloji: "Tekst",
			//default: "Po",
		},
		{
			id: 2,
			kolona: strings?.surnameBuyer,
			plotësimi: `\u25CF ${strings?.forced}`,
			lloji: strings?.text,
			//default: "Po",
		},
		{
			id: 3,
			kolona: strings?.phone,
			plotësimi: `\u25CF ${strings?.forced}`,
			lloji: strings?.number,
		},
		{
			id: 3,
			kolona: strings?.country,
			plotësimi: `\u25CF ${strings?.forced}`,
			lloji: strings?.text,
		},
		{
			id: 5,
			kolona: strings?.city,
			plotësimi: `\u25CF ${strings?.forced}`,
			lloji: strings?.text,
		},
		{
			id: 4,
			kolona: strings?.address,
			plotësimi: `\u25CF ${strings?.forced}`,
			lloji: strings?.text,
		},
		{
			id: 7,
			kolona: strings?.packageName,
			plotësimi: `\u25CF ${strings?.forced}`,
			lloji: strings?.text,
		},
		{
			id: 8,
			kolona: strings?.packageDesc,
			plotësimi: `\u25CF ${strings?.forced}`,
			lloji: strings?.text,
		},
		{
			id: 9,
			kolona: strings?.packageValue,
			plotësimi: `\u25CF ${strings?.forced}`,
			lloji: strings?.number,
		},
		{
			id: 11,
			kolona: strings?.openable,
			plotësimi: `\u25CF ${strings?.forced}`,
			lloji: strings?.yesNo,
		},
		{
			id: 12,
			kolona: strings?.fragile,
			plotësimi: `\u25CF ${strings?.forced}`,
			lloji: strings?.yesNo,
		},
		{
			id: 14,
			kolona: strings?.exchangeable,
			plotësimi: `\u25CF ${strings?.forced}`,
			lloji: strings?.yesNo,
		},
		{
			id: 14,
			kolona: strings?.kodiDoganor,
			plotësimi: `\u25CF ${strings?.optional}`,
			lloji: "Numër",
			default: "86734034",
		},
		{
			id: 14,
			kolona: strings?.width,
			plotësimi: `\u25CF ${strings?.optional}`,
			lloji: "Numër",
			default: "30 (~cm)",
		},
		{
			id: 14,
			kolona: strings?.length,
			plotësimi: `\u25CF ${strings?.optional}`,
			lloji: "Numër",
			default: "30 (~cm)",
		},
		{
			id: 14,
			kolona: strings?.height,
			plotësimi: `\u25CF ${strings?.optional}`,
			lloji: "Numër",
			default: "30 (~cm)",
		},
		{
			id: 14,
			kolona: strings?.weight,
			plotësimi: `\u25CF ${strings?.optional}`,
			lloji: "Numër",
			default: "0.5 (~kg)",
		},
		{
			id: 14,
			kolona: strings?.invoiceLabel,
			plotësimi: `\u25CF ${strings?.forced}`,
			lloji: strings?.yesNo,
		},
	];

	useEffect(() => {
		setTableColumns([
			{
				field: "id",
				headerName: "",
				cellStyle: (params: any) => ({
					fontSize: "15px",
					fontWeight: "600",
				}),
				width: 40,
			},
			{
				field: "kolona",
				headerName: strings?.column,
				width: 140,
			},
			{
				field: "plotësimi",
				headerName: strings?.filling,
				cellStyle: (params: any) => ({
					color:
						params.value === "\u25CF Opcionale"
							? "#8E8E8E"
							: params.value === "\u25CF E detyruar"
							? "#4F16C2"
							: "inherit",
				}),
				width: 120,
			},
			{
				field: "lloji",
				headerName: strings?.type,
				width: 120,
			},
			{
				field: "default",
				headerName: strings?.default,
				width: 110,
			},
		]);
		selectOrderCountByCities();
	}, [setTableColumns]);

	const fetchCustoms = async () => {
		const allCustoms = await getAllCustoms();
		setCustoms(allCustoms);
	};

	const fetchCountryId = async () => {
		try {
			const response = await api.get("Zone/country-id");
			if (response.status === 200) {
				setCountryId(response.data);
			}
		} catch (error) {
			console.error("Error fetching country ID:", error);
		}
	};

	useEffect(() => {
		fetchCustoms();
		fetchCountryId();
		fetchZones()
			.then((response: any) => {
				if (response) {
					setZones(response);
				} else {
					console.error(
						"Expected an array for zones, but received:",
						response
					);
					setZones([]);
				}
			})
			.catch((error: any) => {
				console.error("Error fetching zones:", error);
				setZones([]);
			});
	}, []);

	const filteredCountry = zones.filter((zone: any) => zone.levelId === 1);

	const getPackageSizeId = (size: any) => {
		const lowercaseSize = size.toLowerCase();
		switch (lowercaseSize) {
			case "xs":
				return 1;
			case "s":
				return 2;
			case "m":
				return 3;
			case "l":
				return 4;
			case "xl":
				return 5;
			default:
				return null;
		}
	};

	const getCountryId = (country: string) => {
		const countryCaseSize = country.trim().toLowerCase();
		switch (countryCaseSize) {
			case "kosovo":
				return 1;
			case "shqiperi":
				return 2;
			case "maqedoni":
				return 3;
			case "kosove":
				return 1;
			case "kosovë":
				return 1;
			case "kosov":
				return 1;
			case "albania":
				return 2;
			case "macedonia":
				return 3;
			default:
				return null;
		}
	};

	const [isDisable, setIsDisable] = useState(false);

	const onExcelImport = async (excelData: any) => {
		try {
			setIsDisable(true);
			setLoading(true);
			const orders = excelData?.map((row: any, index: any) => {
				const {
					price,
					openable,
					fragile,
					exchangeable,
					customsId,
					countryId,
					city,
					invoice,
				} = excelRowValidate(row, index);

				return {
					RefId: row.Refid ?? "",
					FirstName: row["Emri i bleresit"],
					LastName: row["Mbiemri i bleresit"],
					Phone: row["Nr. telefonit"],
					CountryId: countryId,
					Address: row["Rruga"],
					AddressDetails: row["Adresa"],
					OrderDescription: row["Emërtimi i pakos"],
					PackageDescription: row["Përshkrimi i pakos"],
					OrderPrice: price,
					OrdersRealPrice: row["Vlera reale e porosisë"]
						? row["Vlera reale e porosisë"]
						: 0,
					Openable: openable,
					Fragile: fragile,
					Exchangeable: exchangeable,
					CustomsId: customsId,
					// CityLabel: row["Qyteti"],
					CityLabel: city,
					Width: row["Gjerësia"] ? row["Gjerësia"] : 20,
					Length: row["Gjatësia"] ? row["Gjatësia"] : 20,
					Height: row["Lartësia"] ? row["Lartësia"] : 20,
					Weight: row["Pesha"] ? row["Pesha"] : 0.5,
					Invoice: invoice,
				};
			});
			api.defaults.timeout = 3600 * 1000;
			const response = await api.post("Order/bulk-insert", orders);
			if (response.status === 200) {
				toast.success(strings?.uploadSuccessMessage);
			} else {
				toast.error(strings?.uploadFailureMessage, response.data);
			}
		} catch (error) {
			console.error("Error in onExcelImport:", error);
			toast.error(`${strings?.uploadErrorMessage} ${error}`);
			setIsDisable(false);
		} finally {
			setLoading(false);
			setIsDisable(false);
		}
	};

	const excelRowValidate = (row: any, index: number) => {
		const requiredFields = [
			"Emri i bleresit",
			"Mbiemri i bleresit",
			"Nr. telefonit",
			"Shteti",
			"Qyteti",
			"Rruga",
			"Adresa",
			"Emërtimi i pakos",
			"Përshkrimi i pakos",
			"Vlera e pakos",
			"Hapet",
			"Thyhet",
			"Ndërrim",
			"Fature e firmosur/Flete Kthimi",
		];

		// Check for missing required fields
		for (const field of requiredFields) {
			const value = row[field];
			if (
				value === undefined ||
				value === null ||
				String(value).trim() === ""
			) {
				throw new Error(
					`Missing required field "${field}" at row ${index + 1}`
				);
			}
		}

		// Remove commas and convert price to a number
		const price = parseFloat(
			(row["Vlera e pakos"] || "0").replace(/,/g, "")
		);
		if (isNaN(price) || price < 0) {
			throw new Error(`Invalid price at row ${index + 1}`);
		}

		const realPrice = parseFloat(
			(row["Vlera reale e porosisë"] || "0").replace(/,/g, "")
		);
		if (price === 0 && (isNaN(realPrice) || realPrice <= 0)) {
			throw new Error(
				`OrdersRealPrice is required and must be greater than 0 at row ${
					index + 1
				} when OrderPrice is zero`
			);
		}

		// Boolean fields processing
		const openable = row["Hapet"]?.toLowerCase() === "po" || false;
		const fragile = row["Thyhet"]?.toLowerCase() === "po" || false;
		const exchangeable = row["Ndërrim"]?.toLowerCase() === "po" || false;
		const invoice =
			row["Fature e firmosur/Flete Kthimi"]?.toLowerCase() === "po" ||
			false;
		if (exchangeable && invoice) {
			throw new Error(
				"Porosia mund te jete Nderrim ose Fature e Firmosur/Flete Kthim"
			);
		}
		let customsId = null;
		const customDescription = row["Kodi doganor"];
		if (customDescription) {
			if (customs) {
				const customDescriptionExists = customs.some(
					(item: any) =>
						item.costumsCode?.replace(/\s+/g, "") ===
						customDescription?.replace(/\s+/g, "")
				);
				if (!customDescriptionExists) {
					throw new Error(`Invalid customs code at row ${index + 1}`);
				} else {
					const customItem = customs.find(
						(item: any) =>
							item.costumsCode.replace(/\s+/g, "") ===
							customDescription.replace(/\s+/g, "")
					);
					customsId = customItem ? customItem.id : null;
				}
			}
		}
		const country =
			typeof row["Shteti"] === "string"
				? row["Shteti"].trim()
				: row["Shteti"];
		const countryId = getCountryId(country);
		if (!countryId) {
			throw new Error(
				"Shteti should be Kosovo, Shqiperia or Maqedoni at row: " +
					index +
					1
			);
		}
		const cities: string[] = zones
			.filter((zone: any) => zone.parentId === countryId)
			.map((city: any) => city.description);
		const city = row["Qyteti"].trim();
		console.log(city, "city");
		validateCity(city, cities);

		// Return validated data
		return {
			price,
			openable,
			fragile,
			exchangeable,
			customsId,
			countryId,
			city,
			invoice,
		};
	};
	function validateCity(city: string, availableCities: string[]): void {
		if (!availableCities.includes(city)) {
			const closestCity = findClosestCity(city, availableCities);
			throw new Error(`City not found. Did you mean "${closestCity}"?`);
		}
	}

	function findClosestCity(
		inputCity: string,
		availableCities: string[]
	): string {
		let closestCity = availableCities[0];
		let minDistance = levenshteinDistance(inputCity, closestCity);

		for (const city of availableCities) {
			const distance = levenshteinDistance(inputCity, city);
			if (distance < minDistance) {
				closestCity = city;
				minDistance = distance;
			}
		}

		return closestCity;
	}

	function levenshteinDistance(a: string, b: string): number {
		const matrix: number[][] = [];

		// Increment along the first column of each row
		for (let i = 0; i <= b.length; i++) {
			matrix[i] = [i];
		}

		// Increment along the first row of each column
		for (let j = 0; j <= a.length; j++) {
			matrix[0][j] = j;
		}

		// Fill in the rest of the matrix
		for (let i = 1; i <= b.length; i++) {
			for (let j = 1; j <= a.length; j++) {
				if (b.charAt(i - 1) === a.charAt(j - 1)) {
					matrix[i][j] = matrix[i - 1][j - 1];
				} else {
					matrix[i][j] = Math.min(
						matrix[i - 1][j - 1] + 1, // substitution
						matrix[i][j - 1] + 1, // insertion
						matrix[i - 1][j] + 1
					); // deletion
				}
			}
		}

		return matrix[b.length][a.length];
	}

	const excelHeader = {
		Refid: "",
		"Emri i bleresit": "",
		"Mbiemri i bleresit": "",
		"Nr. telefonit": "",
		Shteti: "",
		Qyteti: "",
		Rruga: "",
		Adresa: "",
		"Emërtimi i pakos": "",
		"Përshkrimi i pakos": "",
		"Vlera e pakos": "",
		"Vlera reale e porosisë": "",
		Hapet: "",
		Thyhet: "",
		Ndërrim: "",
		"Kodi doganor": "",
		Gjerësia: "",
		Gjatësia: "",
		Lartësia: "",
		Pesha: "",
		"Fature e firmosur/Flete Kthimi": "",
	};

	const selectOrderCountByCities = async () => {
		try {
			const response = await api.get("Order/order-count-by-city", {
				params: { userId: null },
			});
			if (response.status === 200) {
				const result = response?.data;
				setOrdersCountByCity(result);
			}
		} catch (error) {
			console.error("Error fetching data:", error);
		}
	};

	const handleCityHover = (countryId: number, cityName: string) => {
		setExpandedCountryId(countryId);
		setHoveredCity(cityName);
	};

	const handleAccordionChange = (countryId: number) => {
		setExpandedCountryId(
			expandedCountryId === countryId ? null : countryId
		);
	};

	const handleCityClick = (cityName: string) => {
		setHoveredCity(cityName);
	};

	return (
		<>
			{loading ? (
				<Spin spinning={loading} tip={strings?.loadingTip} />
			) : (
				<div className={classes.mainHero}>
					<div className={classes.firstCont}>
						<h1 className={classes.title}>
							{strings?.newOrderTitle}
						</h1>
						<div className={classes.mainFirst}>
							<h1 className={classes.titleinfo}>
								{strings?.buyerDataTitle}
							</h1>
							<div className={classes.firstDiv}>
								<DefaultExcelImport
									onExcelImport={(rows: any) =>
										onExcelImport(rows)
									}
									excelHeaders={excelHeader}
									disable={isDisable}
								/>
							</div>
						</div>
						<div className={classes.secondContainer}>
							<div className={classes.generalInfos}>
								<p className={classes.generalTitle}>
									{strings?.generalInfoTitle}
								</p>
								<div className={classes.warningDiv}>
									<div className="w-auto">
										<InfoIcon />
									</div>{" "}
									<div>
										<p className={classes.secondTitle}>
											{strings?.note}
										</p>
										<p className={classes.info}>
											{strings?.attentionInfo}
										</p>
									</div>
								</div>
								<div className={classes.registerInfo}>
									<p>{strings?.firstRowInfo}</p>
								</div>
								<div
									className="ag-theme-alpine"
									style={{
										width: "80%",
										height: 700,
									}}
								>
									<AgGridReact
										rowData={data}
										columnDefs={tableColumns}
									/>
								</div>
							</div>
							<div className={classes.hartContainer}>
								<p className={classes.hartTitle}>
									{strings?.allowedStatesTitle}
								</p>
								<div className={classes.hart}>
									<h1 className="StatisticTitle">
										{strings?.hart}
									</h1>

									<Map
										ordersCountByCity={ordersCountByCity}
										countryId={countryId}
										onCityHover={handleCityHover}
										hoveredCity={hoveredCity}
									/>
								</div>
								<div>
									{zones
										.filter(
											(zone: any) => zone.levelId === 1
										)
										.map((country: any, index: any) => (
											<Accordion
												key={index}
												className={classes.country}
												expanded={
													expandedCountryId ===
													country.id
												}
												onChange={() =>
													handleAccordionChange(
														country.id
													)
												}
											>
												<AccordionSummary
													expandIcon={<ArrowDown />}
													aria-controls="panel1a-content"
													id="panel1a-header"
												>
													<Typography
														sx={{
															fontWeight: "bold",
														}}
													>
														{country.description}
													</Typography>
												</AccordionSummary>
												<AccordionDetails
													className={classes.cityDiv}
													sx={{ paddingLeft: "15px" }}
												>
													<ul
														className={
															classes.cities
														}
													>
														{zones
															.filter(
																(zone: any) =>
																	zone.parentId ===
																	country.id
															)
															.map(
																(
																	city: any,
																	cityIndex: any
																) => (
																	<li
																		key={
																			cityIndex
																		}
																		style={{
																			color:
																				city.description ===
																				hoveredCity
																					? "#4F16C2"
																					: "inherit",
																		}}
																		onClick={() =>
																			handleCityClick(
																				city.description
																			)
																		}
																	>
																		{
																			city.description
																		}
																	</li>
																)
															)}
													</ul>
												</AccordionDetails>
											</Accordion>
										))}
								</div>
							</div>
						</div>
					</div>
				</div>
			)}
		</>
	);
};

export default RegisterOrders;
